import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

const Footer: React.FC = () => {
  const data = useStaticQuery(graphql`
    query footerQuery {
      growth: wpMenu(id: { eq: "dGVybTo2ODU=" }) {
        name
        menuItems {
          nodes {
            id
            label
            description
            cssClasses
            path
            target
          }
        }
      }
      education: wpMenu(id: { eq: "dGVybTo2ODQ=" }) {
        name
        menuItems {
          nodes {
            id
            label
            description
            cssClasses
            path
            target
          }
        }
      }
      about: wpMenu(id: { eq: "dGVybTo2ODI=" }) {
        name
        menuItems {
          nodes {
            id
            label
            description
            cssClasses
            path
            target
          }
        }
      }
      clientsuccess: wpMenu(id: { eq: "dGVybTo2ODM=" }) {
        name
        menuItems {
          nodes {
            id
            label
            description
            cssClasses
            path
            target
            acfSocialicons {
              hasSocialIcons
              socialIcons {
                socialIconLink
                socialIconCode
              }
            }
          }
        }
      }
      copyright: wp {
        themeOptions {
          acfOptions {
            copyrightText
          }
        }
      }
    }
  `)

  return (
    <div className='footer hidden md:block'>
      <div className='footer__content mx-auto max-w-screen-2xl'>
        <div className='footer__menus grid grid-cols-4 mb-6'>
          <div className='footer-menu'>
            <ul>
              {data?.growth?.menuItems?.nodes.map((item: any) => {
                return (
                  <li key={item.id} className='mb-6'>
                    <Link
                      className={`text-sm tracking-wide hover:text-blue-sky ${item.cssClasses.join(
                        ' '
                      )}`}
                      to={item.path}
                    >
                      {item.label}
                    </Link>
                    <p className='text-tiny text-white mt-1 tracking-wide'>{item.description}</p>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className='footer-menu'>
            <ul>
              {data?.education?.menuItems?.nodes.map((item: any) => {
                return (
                  <li key={item.id} className='mb-5'>
                    <Link
                      className={`text-sm tracking-wide hover:text-blue-sky ${item.cssClasses.join(
                        ' '
                      )}`}
                      to={item.path}
                    >
                      {item.label}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className='footer-menu'>
            <ul>
              {data?.about?.menuItems?.nodes.map((item: any) => {
                return (
                  <li key={item.id} className='mb-5'>
                    <Link
                      className={`text-sm tracking-wide hover:text-blue-sky ${item.cssClasses.join(
                        ' '
                      )}`}
                      to={item.path}
                    >
                      {item.label}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className='footer-menu'>
            <div className='flex flex-col'>
              {data?.clientsuccess?.menuItems?.nodes.map((item: any) => {
                const classNames = item?.cssClasses.join(' ')
                const hasSocialicons = item?.acfSocialicons?.hasSocialIcons
                const socialIcons = item?.acfSocialicons?.socialIcons

                {
                  if (hasSocialicons) {
                    return (
                      <div key={item.id} className='flex mb-8'>
                        {socialIcons.map((social: any) => {
                          return (
                            <a
                              key={social.socialIconLink}
                              className='mr-6'
                              href={social.socialIconLink}
                              target='_blank'
                              rel='noreferrer noopener'
                            >
                              <div
                                dangerouslySetInnerHTML={{ __html: social.socialIconCode }}
                              ></div>
                            </a>
                          )
                        })}
                      </div>
                    )
                  } else {
                    return (
                      <div key={item.id} className='mb-6'>
                        <Link
                          className={`text-sm tracking-wide hover:text-blue-sky ${classNames}`}
                          to={item.path}
                        >
                          {item.label}
                        </Link>
                      </div>
                    )
                  }
                }
              })}
            </div>
          </div>
        </div>
        <div className='h-px bg-gray-light'></div>
        <div className='footer__copyright flex justify-between items-center pt-10'>
          <div className='copyright-logo'>
            <Link to='/'>
              <svg
                className='text-white hover:text-blue-sky transition duration-300 ease-out'
                version='1.1'
                width='220'
                xmlns='http://www.w3.org/2000/svg'
                x='0px'
                y='0px'
                viewBox='0 0 1008 216'
                xml-space='preserve'
              >
                <g>
                  <g>
                    <path
                      fill='currentColor'
                      d='M372.3,118.7h-14.8V61l-26.5,34.5h-4.9l-26.5-34.7v57.8H285V25.2h5l38.6,51.4l38.7-51.4h5V118.7z'
                    />
                    <path
                      fill='currentColor'
                      d='M415.4,48.8c4.2,0,8,0.6,11.4,1.8c3.4,1.2,6.4,3,8.8,5.4c2.5,2.4,4.4,5.3,5.8,8.9c1.4,3.6,2.1,7.7,2.1,12.5
			v41.4h-13.6V111c-2.4,2.9-5.5,5.1-9.2,6.8c-3.7,1.6-7.9,2.4-12.7,2.4c-3.6,0-6.9-0.5-9.8-1.4c-2.9-0.9-5.4-2.3-7.5-4
			c-2.1-1.8-3.7-3.9-4.8-6.3c-1.1-2.4-1.7-5.1-1.7-8.1c0-6,2.3-10.8,6.8-14.3c4.5-3.5,10.7-5.2,18.4-5.2h19.4v-4.5
			c0-4.7-1.3-8.4-3.8-10.9c-2.5-2.5-6.1-3.8-10.9-3.8c-4,0-7.5,0.9-10.4,2.6c-3,1.8-5.8,4.3-8.6,7.5l-8.4-8.6
			c3.5-5,7.7-8.7,12.7-11.1C404.3,49.9,409.7,48.8,415.4,48.8z M411.1,108.9c2.4,0,4.7-0.4,6.8-1.2c2.1-0.8,4-1.9,5.6-3.3
			c1.6-1.4,2.9-3.2,3.8-5.2c0.9-2,1.4-4.2,1.4-6.5v-1.3h-17.5c-3.9,0-6.9,0.7-9,2.1c-2.1,1.4-3.1,3.5-3.1,6.3c0,3,1.2,5.2,3.5,6.8
			C404.9,108.1,407.8,108.9,411.1,108.9z'
                    />
                    <path
                      fill='currentColor'
                      d='M490.5,49.6c1.2,0,2.3,0.1,3.1,0.2c0.9,0.1,1.7,0.3,2.4,0.5v12.9h-4.5c-2.7,0-5.3,0.4-7.7,1.2
			c-2.5,0.8-4.6,2-6.4,3.6c-1.8,1.6-3.3,3.6-4.3,5.9c-1.1,2.4-1.6,5.1-1.6,8.3v36.5H457V50.3h13.5v9.2c2.4-3.2,5.4-5.7,8.8-7.4
			C482.8,50.4,486.5,49.6,490.5,49.6z'
                    />
                    <path
                      fill='currentColor'
                      d='M522.9,118.7h-14.6V22.8h14.6V118.7z M538.2,80.5l27.7,38.2h-18.2l-26.7-38.4l26.7-29.9h18.2L538.2,80.5z'
                    />
                    <path
                      fill='currentColor'
                      d='M601.4,48.8c4.5,0,8.8,0.8,12.7,2.4c3.9,1.6,7.2,3.8,10,6.5c2.8,2.8,5,6.1,6.5,10c1.6,3.9,2.4,8,2.4,12.5
			c0,1.9-0.1,3.6-0.3,5.3c-0.2,1.7-0.5,3-0.8,3.9h-51c1,5.7,3.5,10.1,7.5,13.2c4,3.2,8.9,4.7,14.8,4.7c4,0,7.6-0.7,10.9-2.2
			c3.2-1.4,6.3-3.4,9.1-5.9l7.1,10c-3.6,3.4-7.7,6.1-12.3,8.1c-4.5,1.9-9.6,2.9-15,2.9c-5.3,0-10.2-0.9-14.8-2.7
			c-4.5-1.8-8.4-4.3-11.7-7.5c-3.3-3.2-5.8-7-7.7-11.3c-1.9-4.4-2.8-9.1-2.8-14.1c0-5,0.9-9.7,2.7-14.1c1.8-4.4,4.3-8.1,7.5-11.3
			c3.2-3.2,6.9-5.7,11.2-7.6C591.8,49.7,596.4,48.8,601.4,48.8z M601,61.2c-5,0-9.3,1.5-12.8,4.5c-3.5,3-5.8,7.1-7,12.2h37.2
			c-0.2-5.4-2-9.5-5.4-12.4C609.6,62.6,605.6,61.2,601,61.2z'
                    />
                    <path
                      fill='currentColor'
                      d='M688.5,63H668v32.2c0,4.5,1.2,7.7,3.6,9.3c2.4,1.7,5.7,2.5,10.1,2.5c1.2,0,2.6-0.1,4-0.2
			c1.5-0.1,3.1-0.3,4.9-0.5v12.4c-1.9,0.5-3.7,0.8-5.6,1.1c-1.9,0.3-4,0.4-6.3,0.4c-7.6,0-13.7-1.9-18.3-5.7
			c-4.6-3.8-6.9-9.8-6.9-18.1V63h-11.1V50.3h11.1V29.9H668v20.4h20.5V63z'
                    />
                    <path
                      fill='currentColor'
                      d='M774.6,94.6l15.3-44.3h15.5l-27.8,69.9h-5l-21.6-43.2L732,120.2h-5l-30.4-69.9h15.6l18,44.7l18.3-46.2h5
			L774.6,94.6z'
                    />
                    <path
                      fill='currentColor'
                      d='M841.2,48.8c4.2,0,8,0.6,11.4,1.8c3.4,1.2,6.4,3,8.8,5.4c2.5,2.4,4.4,5.3,5.8,8.9c1.4,3.6,2.1,7.7,2.1,12.5
			v41.4h-13.6V111c-2.4,2.9-5.5,5.1-9.2,6.8c-3.7,1.6-7.9,2.4-12.7,2.4c-3.6,0-6.9-0.5-9.8-1.4c-2.9-0.9-5.4-2.3-7.5-4
			c-2.1-1.8-3.7-3.9-4.8-6.3c-1.1-2.4-1.7-5.1-1.7-8.1c0-6,2.3-10.8,6.8-14.3c4.5-3.5,10.7-5.2,18.4-5.2h19.4v-4.5
			c0-4.7-1.3-8.4-3.8-10.9c-2.5-2.5-6.1-3.8-10.9-3.8c-4,0-7.5,0.9-10.4,2.6c-3,1.8-5.8,4.3-8.6,7.5l-8.4-8.6
			c3.5-5,7.7-8.7,12.7-11.1C830.1,49.9,835.4,48.8,841.2,48.8z M836.9,108.9c2.4,0,4.7-0.4,6.8-1.2c2.1-0.8,4-1.9,5.6-3.3
			c1.6-1.4,2.9-3.2,3.8-5.2c0.9-2,1.4-4.2,1.4-6.5v-1.3H837c-3.9,0-6.9,0.7-9,2.1c-2.1,1.4-3.1,3.5-3.1,6.3c0,3,1.2,5.2,3.5,6.8
			C830.7,108.1,833.5,108.9,836.9,108.9z'
                    />
                    <path
                      fill='currentColor'
                      d='M917.5,49.6c1.2,0,2.2,0.1,3.1,0.2c0.9,0.1,1.7,0.3,2.4,0.5v12.9h-4.5c-2.7,0-5.3,0.4-7.7,1.2
			c-2.5,0.8-4.6,2-6.4,3.6c-1.8,1.6-3.3,3.6-4.3,5.9c-1.1,2.4-1.6,5.1-1.6,8.3v36.5h-14.6V50.3h13.5v9.2c2.4-3.2,5.4-5.7,8.8-7.4
			C909.7,50.4,913.5,49.6,917.5,49.6z'
                    />
                    <path
                      fill='currentColor'
                      d='M963.7,48.8c4.5,0,8.8,0.8,12.7,2.4c3.9,1.6,7.2,3.8,10,6.5c2.8,2.8,5,6.1,6.5,10c1.6,3.9,2.4,8,2.4,12.5
			c0,1.9-0.1,3.6-0.3,5.3c-0.2,1.7-0.5,3-0.8,3.9h-51c1,5.7,3.5,10.1,7.5,13.2c4,3.2,8.9,4.7,14.8,4.7c4,0,7.6-0.7,10.9-2.2
			c3.2-1.4,6.3-3.4,9.1-5.9l7.1,10c-3.6,3.4-7.7,6.1-12.3,8.1c-4.5,1.9-9.6,2.9-15,2.9c-5.3,0-10.2-0.9-14.8-2.7
			c-4.5-1.8-8.4-4.3-11.7-7.5c-3.3-3.2-5.8-7-7.7-11.3c-1.9-4.4-2.8-9.1-2.8-14.1c0-5,0.9-9.7,2.7-14.1c1.8-4.4,4.3-8.1,7.5-11.3
			c3.2-3.2,6.9-5.7,11.2-7.6C954,49.7,958.7,48.8,963.7,48.8z M963.3,61.2c-5,0-9.3,1.5-12.8,4.5c-3.5,3-5.8,7.1-7,12.2h37.2
			c-0.2-5.4-2-9.5-5.4-12.4C971.9,62.6,967.9,61.2,963.3,61.2z'
                    />
                  </g>
                  <g>
                    <g>
                      <path
                        fill='currentColor'
                        d='M162.9,69.5L162.9,69.5c-2.1-2.1-2.1-5.4,0-7.4l26.7-26.7c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4
				l-26.7,26.7C168.3,71.5,164.9,71.5,162.9,69.5z M209.4,63.7l4.3-4.3c2.1-2.1,2.1-5.4,0-7.4l0,0c-2.1-2.1-5.4-2.1-7.4,0l-4.3,4.3
				c-2.1,2.1-2.1,5.4,0,7.4l0,0C204,65.8,207.3,65.8,209.4,63.7z M43.2,96.7l64.9-64.9c2.1-2.1,2.1-5.4,0-7.4l0,0
				c-2.1-2.1-5.4-2.1-7.4,0L35.8,89.2c-2.1,2.1-2.1,5.4,0,7.4l0,0C37.8,98.7,41.2,98.7,43.2,96.7z M30.9,101.5L30.9,101.5
				c2.1,2.1,2.1,5.4,0,7.4l-9.2,9.2c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l9.2-9.2C25.5,99.5,28.9,99.5,30.9,101.5z
				 M48.2,118.8l-1.3-1.3c-1.7-1.7-1.7-4.4,0-6.1l71-71c1.7-1.7,4.4-1.7,6.1,0l1.3,1.3c1.7,1.7,1.7,4.4,0,6.1l-71,71
				C52.7,120.5,49.9,120.5,48.2,118.8z M148,118.9l-1.3-1.3c-1.7-1.7-1.7-4.4,0-6.1l21.2-21.2c1.7-1.7,4.4-1.7,6.1,0l1.3,1.3
				c1.7,1.7,1.7,4.4,0,6.1l-21.2,21.2C152.5,120.6,149.7,120.6,148,118.9z M215.7,117.9l-1.3-1.3c-1.7-1.7-1.7-4.4,0-6.1l25.8-25.8
				c1.7-1.7,4.4-1.7,6.1,0l1.3,1.3c1.7,1.7,1.7,4.4,0,6.1l-25.8,25.8C220.1,119.6,217.4,119.6,215.7,117.9z M247.7,119.3l-1.3-1.3
				c-1.7-1.7-1.7-4.4,0-6.1l10.5-10.5c1.7-1.7,4.4-1.7,6.1,0l1.3,1.3c1.7,1.7,1.7,4.4,0,6.1l-10.5,10.5
				C252.2,121,249.4,121,247.7,119.3z M158.1,74.3L158.1,74.3c2.1,2.1,2.1,5.4,0,7.4l-36.5,36.5c-2.1,2.1-5.4,2.1-7.4,0l0,0
				c-2.1-2.1-2.1-5.4,0-7.4l36.5-36.5C152.7,72.3,156,72.3,158.1,74.3z M196.2,102.8L196.2,102.8c-2.1-2.1-2.1-5.4,0-7.4l26.7-26.7
				c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4l-26.7,26.7C201.6,104.8,198.2,104.8,196.2,102.8z M191.4,107.6L191.4,107.6
				c2.1,2.1,2.1,5.4,0,7.4l-3.4,3.4c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l3.4-3.4C186,105.6,189.3,105.6,191.4,107.6z
				 M197.1,68.6L197.1,68.6c2.1,2.1,2.1,5.4,0,7.4L187,86.1c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l10.1-10.1
				C191.7,66.5,195.1,66.5,197.1,68.6z M114.1,85L114.1,85c2.1,2.1,2.1,5.4,0,7.4l-25.4,25.4c-2.1,2.1-5.4,2.1-7.4,0l0,0
				c-2.1-2.1-2.1-5.4,0-7.4L106.6,85C108.7,82.9,112,82.9,114.1,85z M118.9,80.2L118.9,80.2c-2.1-2.1-2.1-5.4,0-7.4L134,57.7
				c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4l-15.1,15.1C124.3,82.2,121,82.2,118.9,80.2z'
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        fill='currentColor'
                        d='M510.6,192.8h-3.1l-1.3-5.3h-12.7l-3.1,5.3h-3.5l16-26.5h1.1L510.6,192.8z M495.2,184.7h10.3l-2.9-12.6
				L495.2,184.7z'
                      />
                      <path
                        fill='currentColor'
                        d='M542.4,192.8h-2.8l0.5-2.6c-0.9,1-1.9,1.8-3.2,2.3c-1.2,0.5-2.5,0.8-3.8,0.8c-1.3,0-2.5-0.2-3.6-0.7
				c-1.1-0.5-2-1.1-2.7-2c-0.8-0.8-1.3-1.8-1.7-2.9c-0.4-1.1-0.6-2.2-0.6-3.5c0-1.3,0.2-2.5,0.7-3.8c0.4-1.3,1.1-2.4,2-3.5
				c0.9-1,1.9-1.9,3.2-2.5c1.3-0.6,2.8-1,4.5-1c1.8,0,3.3,0.4,4.5,1.1c1.2,0.7,2.2,1.6,2.8,2.6l2.5-14h3L542.4,192.8z M535,176.3
				c-1.1,0-2.1,0.2-3,0.6c-0.9,0.4-1.7,1-2.4,1.7c-0.7,0.7-1.2,1.5-1.6,2.4c-0.4,0.9-0.6,1.9-0.6,2.9c0,0.9,0.1,1.7,0.4,2.5
				c0.3,0.8,0.7,1.5,1.2,2.1c0.5,0.6,1.2,1.1,2,1.4c0.8,0.3,1.7,0.5,2.7,0.5c1.2,0,2.3-0.3,3.2-0.8c0.9-0.5,1.7-1.1,2.3-1.9
				s1.1-1.6,1.4-2.6c0.3-0.9,0.5-1.8,0.5-2.7c0-1-0.2-1.8-0.5-2.6c-0.3-0.8-0.8-1.4-1.4-1.9c-0.6-0.5-1.2-0.9-2-1.2
				C536.6,176.4,535.8,176.3,535,176.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M552.2,192.8h-3l3.3-18.9h3L552.2,192.8z M555.3,164c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6
				c0,0.6-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.6-1.6,0.6c-0.6,0-1.1-0.2-1.6-0.6c-0.4-0.4-0.7-0.9-0.7-1.6c0-0.6,0.2-1.1,0.7-1.6
				C554.2,164.2,554.7,164,555.3,164z'
                      />
                      <path
                        fill='currentColor'
                        d='M566.3,193.2h-1.1l-5.7-19.3h3l3.9,14.1l8.9-14.1h3.4L566.3,193.2z'
                      />
                      <path
                        fill='currentColor'
                        d='M583.1,192.8h-3l3.3-18.9h3L583.1,192.8z M586.2,164c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6
				c0,0.6-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.6-1.6,0.6c-0.6,0-1.1-0.2-1.6-0.6c-0.4-0.4-0.7-0.9-0.7-1.6c0-0.6,0.2-1.1,0.7-1.6
				C585.1,164.2,585.6,164,586.2,164z'
                      />
                      <path
                        fill='currentColor'
                        d='M598.1,173.5c1.5,0,2.8,0.3,3.9,0.9c1.1,0.6,1.9,1.4,2.6,2.4l-2.1,1.7c-0.6-0.7-1.2-1.3-2-1.7
				c-0.8-0.4-1.6-0.6-2.6-0.6c-0.9,0-1.6,0.2-2.3,0.6c-0.6,0.4-1,0.9-1,1.7c0,0.6,0.2,1.1,0.7,1.5s1.1,0.8,2,1.3l1.7,0.9
				c1.5,0.8,2.7,1.5,3.4,2.3c0.7,0.8,1.1,1.8,1.1,3c0,0.9-0.2,1.8-0.6,2.5c-0.4,0.7-0.9,1.3-1.6,1.8c-0.7,0.5-1.4,0.8-2.2,1.1
				c-0.8,0.2-1.7,0.4-2.6,0.4c-0.9,0-1.8-0.1-2.5-0.4c-0.8-0.2-1.5-0.5-2.1-0.9c-0.6-0.4-1.2-0.8-1.7-1.3c-0.5-0.5-0.9-1.1-1.2-1.6
				l2.3-1.8c0.3,0.4,0.7,0.9,1,1.3c0.4,0.4,0.7,0.7,1.2,1c0.4,0.3,0.9,0.5,1.4,0.7c0.5,0.2,1.1,0.3,1.7,0.3c1.1,0,2-0.2,2.7-0.7
				c0.8-0.5,1.1-1.1,1.1-2c0-0.7-0.3-1.3-0.8-1.7c-0.5-0.4-1.3-0.8-2.2-1.3l-1.8-0.9c-1.3-0.7-2.3-1.4-3-2.1c-0.7-0.8-1.1-1.8-1.1-3
				c0-0.9,0.2-1.6,0.5-2.3c0.4-0.7,0.8-1.2,1.4-1.7c0.6-0.4,1.3-0.8,2.1-1C596.4,173.6,597.3,173.5,598.1,173.5z'
                      />
                      <path
                        fill='currentColor'
                        d='M610.8,192.8h-3l3.3-18.9h3L610.8,192.8z M614,164c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6
				c0,0.6-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.6-1.6,0.6c-0.6,0-1.1-0.2-1.6-0.6c-0.4-0.4-0.7-0.9-0.7-1.6c0-0.6,0.2-1.1,0.7-1.6
				C612.9,164.2,613.4,164,614,164z'
                      />
                      <path
                        fill='currentColor'
                        d='M628.4,173.5c1.3,0,2.6,0.2,3.8,0.7c1.2,0.5,2.2,1.2,3,2c0.9,0.8,1.5,1.8,2,3c0.5,1.1,0.7,2.4,0.7,3.7
				c0,1.4-0.3,2.8-0.9,4.1c-0.6,1.3-1.4,2.4-2.4,3.3c-1,0.9-2.1,1.7-3.4,2.2c-1.3,0.5-2.7,0.8-4.1,0.8c-1.4,0-2.6-0.2-3.8-0.7
				c-1.2-0.5-2.2-1.1-3-2c-0.9-0.8-1.5-1.8-2-3c-0.5-1.1-0.7-2.4-0.7-3.7c0-1.5,0.3-2.8,0.9-4.1c0.6-1.3,1.4-2.4,2.3-3.3
				c1-0.9,2.1-1.7,3.4-2.2C625.6,173.7,627,173.5,628.4,173.5z M628.3,176.3c-1,0-2,0.2-2.9,0.6c-0.9,0.4-1.7,0.9-2.4,1.6
				c-0.7,0.7-1.2,1.5-1.6,2.4c-0.4,0.9-0.6,1.9-0.6,3c0,0.9,0.2,1.8,0.5,2.6c0.3,0.8,0.8,1.5,1.3,2.1c0.6,0.6,1.3,1,2.1,1.4
				c0.8,0.3,1.7,0.5,2.6,0.5c1,0,2-0.2,2.9-0.6c0.9-0.4,1.7-0.9,2.4-1.6c0.7-0.7,1.2-1.5,1.6-2.4c0.4-0.9,0.6-1.9,0.6-2.9
				c0-0.9-0.2-1.8-0.5-2.6c-0.3-0.8-0.8-1.5-1.4-2.1c-0.6-0.6-1.3-1.1-2.1-1.4C630.1,176.5,629.3,176.3,628.3,176.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M653.3,173.5c1,0,1.9,0.2,2.7,0.5c0.8,0.3,1.5,0.8,2.1,1.3c0.6,0.6,1,1.2,1.3,2c0.3,0.8,0.5,1.6,0.5,2.5
				c0,0.3,0,0.7-0.1,1c0,0.3-0.1,0.7-0.2,1.2l-1.9,10.9h-3l1.9-11c0.1-0.3,0.1-0.6,0.1-0.8c0-0.2,0.1-0.5,0.1-0.8
				c0-1.3-0.4-2.2-1.1-2.9c-0.8-0.7-1.8-1-3.1-1c-1.4,0-2.6,0.4-3.7,1.2c-1.1,0.8-1.7,2-2,3.5l-2.1,11.8h-3l3.3-18.9h2.8l-0.3,1.9
				c0.7-0.7,1.5-1.3,2.5-1.7C651,173.7,652.1,173.5,653.3,173.5z'
                      />
                      <path
                        fill='currentColor'
                        d='M686.1,173.5c1.3,0,2.6,0.2,3.8,0.7c1.2,0.5,2.2,1.2,3,2c0.9,0.8,1.5,1.8,2,3c0.5,1.1,0.7,2.4,0.7,3.7
				c0,1.4-0.3,2.8-0.9,4.1c-0.6,1.3-1.4,2.4-2.4,3.3c-1,0.9-2.1,1.7-3.4,2.2c-1.3,0.5-2.7,0.8-4.1,0.8c-1.4,0-2.6-0.2-3.8-0.7
				c-1.2-0.5-2.2-1.1-3-2c-0.9-0.8-1.5-1.8-2-3c-0.5-1.1-0.7-2.4-0.7-3.7c0-1.5,0.3-2.8,0.9-4.1c0.6-1.3,1.4-2.4,2.3-3.3
				c1-0.9,2.1-1.7,3.4-2.2C683.3,173.7,684.6,173.5,686.1,173.5z M686,176.3c-1,0-2,0.2-2.9,0.6c-0.9,0.4-1.7,0.9-2.4,1.6
				c-0.7,0.7-1.2,1.5-1.6,2.4c-0.4,0.9-0.6,1.9-0.6,3c0,0.9,0.2,1.8,0.5,2.6c0.3,0.8,0.8,1.5,1.3,2.1c0.6,0.6,1.3,1,2.1,1.4
				c0.8,0.3,1.7,0.5,2.6,0.5c1,0,2-0.2,2.9-0.6c0.9-0.4,1.7-0.9,2.4-1.6c0.7-0.7,1.2-1.5,1.6-2.4c0.4-0.9,0.6-1.9,0.6-2.9
				c0-0.9-0.2-1.8-0.5-2.6c-0.3-0.8-0.8-1.5-1.4-2.1s-1.3-1.1-2.1-1.4C687.8,176.5,686.9,176.3,686,176.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M710.5,176.6h-4.8l-3.2,18c-0.4,2-1.1,3.5-2.3,4.3c-1.2,0.9-2.6,1.3-4.2,1.3c-1.1,0-2.1-0.2-3.1-0.6l0.4-2.5
				c0.9,0.2,1.7,0.3,2.3,0.3c1.1,0,1.9-0.3,2.6-0.8c0.7-0.5,1.2-1.5,1.4-2.9l3-17.3h-2.7l0.5-2.7h2.7l1-5.5c0.4-2,1.1-3.5,2.3-4.4
				c1.2-0.9,2.6-1.4,4.3-1.4c1,0,2.1,0.2,3.2,0.6l-0.4,2.5c-0.9-0.2-1.7-0.2-2.3-0.2c-1.1,0-2,0.3-2.7,0.8c-0.7,0.5-1.2,1.5-1.4,2.8
				l-0.9,4.8h4.8L710.5,176.6z'
                      />
                    </g>
                    <g>
                      <path
                        fill='currentColor'
                        d='M764.1,192.6h-5.6v-21.7l-10,13h-1.8l-10-13.1v21.8h-5.6v-35.2h1.9l14.6,19.4l14.6-19.4h1.9V192.6z'
                      />
                      <path
                        fill='currentColor'
                        d='M783.9,166.3c1.7,0,3.3,0.3,4.8,0.9c1.5,0.6,2.7,1.4,3.8,2.5c1.1,1.1,1.9,2.3,2.5,3.8c0.6,1.5,0.9,3,0.9,4.7
				c0,0.7,0,1.4-0.1,2c-0.1,0.6-0.2,1.1-0.3,1.5h-19.2c0.4,2.1,1.3,3.8,2.8,5c1.5,1.2,3.4,1.8,5.6,1.8c1.5,0,2.9-0.3,4.1-0.8
				c1.2-0.5,2.4-1.3,3.4-2.2l2.7,3.8c-1.4,1.3-2.9,2.3-4.6,3c-1.7,0.7-3.6,1.1-5.7,1.1c-2,0-3.9-0.3-5.6-1c-1.7-0.7-3.2-1.6-4.4-2.8
				c-1.2-1.2-2.2-2.6-2.9-4.3c-0.7-1.6-1.1-3.4-1.1-5.3c0-1.9,0.3-3.7,1-5.3c0.7-1.6,1.6-3.1,2.8-4.3c1.2-1.2,2.6-2.2,4.2-2.9
				C780.3,166.6,782,166.3,783.9,166.3z M783.8,171c-1.9,0-3.5,0.6-4.8,1.7c-1.3,1.1-2.2,2.7-2.6,4.6h14c-0.1-2-0.7-3.6-2-4.7
				C787,171.5,785.5,171,783.8,171z'
                      />
                      <path
                        fill='currentColor'
                        d='M827.3,192.6h-5.1V189c-1,1.3-2.3,2.4-3.8,3.1c-1.6,0.7-3.3,1.1-5.2,1.1c-1.9,0-3.6-0.3-5.1-1
				c-1.5-0.7-2.9-1.6-4-2.8c-1.1-1.2-2-2.6-2.6-4.3c-0.6-1.6-0.9-3.4-0.9-5.3c0-1.9,0.3-3.7,0.9-5.4c0.6-1.6,1.5-3.1,2.6-4.3
				c1.1-1.2,2.5-2.2,4-2.8c1.5-0.7,3.2-1,5.1-1c1.8,0,3.4,0.3,4.9,1c1.5,0.7,2.7,1.6,3.7,2.8V155h5.5V192.6z M814,171.3
				c-1.1,0-2.2,0.2-3.1,0.6c-0.9,0.4-1.8,1-2.5,1.7c-0.7,0.7-1.3,1.6-1.7,2.7c-0.4,1-0.6,2.2-0.6,3.4c0,1.3,0.2,2.4,0.6,3.4
				c0.4,1,1,1.9,1.7,2.7c0.7,0.7,1.5,1.3,2.5,1.7c1,0.4,2,0.6,3.1,0.6c0.9,0,1.9-0.2,2.8-0.5c0.9-0.3,1.8-0.8,2.5-1.5
				c0.7-0.7,1.3-1.6,1.8-2.6c0.5-1.1,0.7-2.3,0.7-3.8c0-1.5-0.2-2.7-0.7-3.8c-0.4-1.1-1-1.9-1.8-2.6c-0.7-0.7-1.6-1.2-2.5-1.5
				C816,171.5,815,171.3,814,171.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M843.5,166.3c1.9,0,3.6,0.3,5.1,1c1.5,0.7,2.8,1.7,3.9,3l-3,3.4c-0.8-0.8-1.8-1.5-2.8-1.9
				c-1.1-0.5-2.1-0.7-3.3-0.7c-1,0-1.9,0.2-2.5,0.6c-0.7,0.4-1,1-1,1.9c0,0.7,0.3,1.3,0.8,1.7c0.6,0.4,1.4,0.9,2.6,1.4l2.4,1
				c2.3,1,4.1,2,5.3,3.2c1.2,1.2,1.8,2.7,1.8,4.6c0,1.3-0.3,2.4-0.8,3.4c-0.5,1-1.2,1.8-2.1,2.5c-0.9,0.7-1.9,1.2-3,1.5
				c-1.2,0.3-2.4,0.5-3.7,0.5c-2.3,0-4.3-0.5-6.1-1.4c-1.8-0.9-3.2-2.1-4.3-3.6l3.1-3.5c1.1,1.1,2.2,2,3.3,2.7c1.2,0.7,2.5,1,4,1
				c1.1,0,2.1-0.2,2.9-0.7c0.8-0.5,1.2-1.2,1.2-2.2c0-0.8-0.3-1.5-1-1.9c-0.7-0.4-1.5-0.9-2.6-1.3l-2.6-1.1c-1.1-0.4-2-0.9-2.8-1.3
				c-0.8-0.5-1.5-1-2.1-1.6c-0.6-0.6-1-1.3-1.3-2c-0.3-0.7-0.5-1.6-0.5-2.6c0-1.2,0.2-2.2,0.7-3.2c0.5-0.9,1.1-1.7,1.9-2.3
				c0.8-0.6,1.8-1.1,2.9-1.4C841.1,166.4,842.3,166.3,843.5,166.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M873.3,166.3c1.8,0,3.5,0.3,5.1,1c1.6,0.7,2.9,1.6,4,2.8c1.1,1.2,2,2.6,2.6,4.3c0.6,1.6,0.9,3.4,0.9,5.3
				c0,1.9-0.3,3.7-0.9,5.4c-0.6,1.6-1.5,3.1-2.7,4.3c-1.1,1.2-2.5,2.2-4,2.8c-1.5,0.7-3.2,1-5,1c-1.8,0-3.4-0.3-4.9-0.9
				c-1.5-0.6-2.7-1.5-3.7-2.7v12.6h-5.5v-35.2h5.1v3.7c0.9-1.4,2.2-2.4,3.8-3.2C869.7,166.7,871.4,166.3,873.3,166.3z M872.4,171.3
				c-0.9,0-1.9,0.2-2.8,0.5c-0.9,0.3-1.8,0.8-2.5,1.5c-0.7,0.7-1.3,1.5-1.8,2.6c-0.5,1.1-0.7,2.3-0.7,3.8c0,1.5,0.2,2.7,0.7,3.8
				c0.4,1.1,1,1.9,1.8,2.6c0.7,0.7,1.6,1.2,2.5,1.5c0.9,0.3,1.9,0.5,2.9,0.5c1.1,0,2.1-0.2,3.1-0.6c1-0.4,1.8-1,2.5-1.7
				c0.7-0.7,1.3-1.6,1.7-2.7c0.4-1,0.6-2.2,0.6-3.4c0-1.3-0.2-2.4-0.6-3.4c-0.4-1-1-1.9-1.7-2.7c-0.7-0.7-1.5-1.3-2.5-1.7
				C874.6,171.5,873.6,171.3,872.4,171.3z'
                      />
                      <path
                        fill='currentColor'
                        d='M897.9,169.5c0.9-1,1.9-1.8,3.2-2.4c1.2-0.6,2.7-0.8,4.3-0.8c1.5,0,2.8,0.3,4,0.8c1.2,0.5,2.2,1.2,3,2.1
				c0.8,0.9,1.5,2,1.9,3.2c0.4,1.3,0.7,2.6,0.7,4.1v16.1h-5.6v-15.3c0-1.8-0.5-3.2-1.5-4.3c-1-1.1-2.4-1.7-4.1-1.7
				c-1.7,0-3.1,0.6-4.2,1.7s-1.7,2.5-1.7,4.3v15.3h-5.5V155h5.5V169.5z'
                      />
                      <path
                        fill='currentColor'
                        d='M934.3,166.3c1.7,0,3.3,0.3,4.8,0.9c1.5,0.6,2.7,1.4,3.8,2.5c1.1,1.1,1.9,2.3,2.5,3.8c0.6,1.5,0.9,3,0.9,4.7
				c0,0.7,0,1.4-0.1,2c-0.1,0.6-0.2,1.1-0.3,1.5h-19.2c0.4,2.1,1.3,3.8,2.8,5c1.5,1.2,3.4,1.8,5.6,1.8c1.5,0,2.9-0.3,4.1-0.8
				c1.2-0.5,2.4-1.3,3.4-2.2l2.7,3.8c-1.4,1.3-2.9,2.3-4.6,3c-1.7,0.7-3.6,1.1-5.7,1.1c-2,0-3.9-0.3-5.6-1c-1.7-0.7-3.2-1.6-4.4-2.8
				c-1.2-1.2-2.2-2.6-2.9-4.3c-0.7-1.6-1.1-3.4-1.1-5.3c0-1.9,0.3-3.7,1-5.3c0.7-1.6,1.6-3.1,2.8-4.3c1.2-1.2,2.6-2.2,4.2-2.9
				C930.6,166.6,932.4,166.3,934.3,166.3z M934.1,171c-1.9,0-3.5,0.6-4.8,1.7c-1.3,1.1-2.2,2.7-2.6,4.6h14c-0.1-2-0.7-3.6-2-4.7
				C937.4,171.5,935.9,171,934.1,171z'
                      />
                      <path
                        fill='currentColor'
                        d='M965.1,166.6c0.5,0,0.8,0,1.2,0.1c0.3,0.1,0.6,0.1,0.9,0.2v4.9h-1.7c-1,0-2,0.1-2.9,0.4
				c-0.9,0.3-1.7,0.7-2.4,1.3c-0.7,0.6-1.2,1.3-1.6,2.2c-0.4,0.9-0.6,1.9-0.6,3.1v13.8h-5.5v-25.8h5.1v3.5c0.9-1.2,2-2.2,3.3-2.8
				C962.2,166.9,963.6,166.6,965.1,166.6z'
                      />
                      <path
                        fill='currentColor'
                        d='M983.4,166.3c1.7,0,3.3,0.3,4.8,0.9c1.5,0.6,2.7,1.4,3.8,2.5c1.1,1.1,1.9,2.3,2.5,3.8c0.6,1.5,0.9,3,0.9,4.7
				c0,0.7,0,1.4-0.1,2c-0.1,0.6-0.2,1.1-0.3,1.5h-19.2c0.4,2.1,1.3,3.8,2.8,5c1.5,1.2,3.4,1.8,5.6,1.8c1.5,0,2.9-0.3,4.1-0.8
				c1.2-0.5,2.4-1.3,3.4-2.2l2.7,3.8c-1.4,1.3-2.9,2.3-4.6,3c-1.7,0.7-3.6,1.1-5.7,1.1c-2,0-3.9-0.3-5.6-1c-1.7-0.7-3.2-1.6-4.4-2.8
				c-1.2-1.2-2.2-2.6-2.9-4.3c-0.7-1.6-1.1-3.4-1.1-5.3c0-1.9,0.3-3.7,1-5.3c0.7-1.6,1.6-3.1,2.8-4.3c1.2-1.2,2.6-2.2,4.2-2.9
				C979.7,166.6,981.5,166.3,983.4,166.3z M983.2,171c-1.9,0-3.5,0.6-4.8,1.7c-1.3,1.1-2.2,2.7-2.6,4.6h14c-0.1-2-0.7-3.6-2-4.7
				C986.5,171.5,985,171,983.2,171z'
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </Link>
          </div>
          {data?.copyright?.themeOptions?.acfOptions?.copyrightText && (
            <div className='body-4'>{data?.copyright?.themeOptions?.acfOptions?.copyrightText}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Footer
